import io from "socket.io-client"
import config from "@configs"
import uuid from "uuid"

let deviceClientId = uuid.v4()
let deviceVoiceClientId = uuid.v4()
let wsUrl = config.url.ws
if (location.protocol.indexOf('https') !== -1) {
    wsUrl = wsUrl.replace('ws://', 'wss://')
}
const scanUploadClient = io(`${wsUrl}/scan-upload`)
const backendClient = io(`${wsUrl}/backend`)
const deviceClient = io(`${wsUrl}/device?deviceId=${deviceClientId}`)
const deviceVoiceClient = io(`${wsUrl}/device?deviceId=${deviceVoiceClientId}`)
export {
    scanUploadClient,
    backendClient,
    deviceClient,
    deviceClientId,
    deviceVoiceClient,
    deviceVoiceClientId
}